import { useState } from "react";
import ConfirmModal from "./ConfirmModal";
import CommonModal from "./DumpModal";
import InputField from "./InputField";
import { useUserInfo } from "../../../../../context/user";
import { useSubmitOnboarding } from "../../../../../queries/settingsAccount";

const LoadURLModal = ({
  isOpen,
  onClose,
  setModal,
  currentSource,
}) => {
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newUrl, setNewUrl] = useState("");
  const userActiveLocation = useUserInfo()[4];
  const submitOnboarding = useSubmitOnboarding(userActiveLocation.id);

  const handleConfirmModal = () => {
    setOpenConfirmModal(!openConfirmModal);
    setModal(false);
  };

  const handleConfirmClick = async () => {
    setLoading(true);
    if (newUrl !== "") {
      try {
        const response = await submitOnboarding.mutateAsync({
          website_url: newUrl,
          profileId: userActiveLocation.id,
          username: userActiveLocation.business_name,
        });
        if (response) {
          setOpenConfirmModal(false);
        }
      } catch (err) {
        alert(err.message);
        console.log(err);
      }
    }
    setLoading(false);
  };
  return (
    <>
      <CommonModal onClose={onClose} isOpen={isOpen} title="Edit URL">
        <div className="mt-4">
          <label htmlFor="source" className="text-muted-foreground text-md">
            Current web address
          </label>
          <InputField
            id="source"
            value={
              currentSource?.website_url || currentSource?.file_name || "form"
            }
            disabled
            classNames="!bg-muted focus:!border-border"
          />

          <div className="mt-4">
            <label htmlFor="new-file" className="text-muted-foreground text-md">
              New web address
            </label>
            <InputField
              id="new-file"
              value={newUrl}
              placeholder="Enter new web address"
              onChange={(e) => setNewUrl(e.target.value)}
              classNames="focus:!border-border"
            />
            <button
              className={`mt-4 text-center w-full rounded-md py-3 text-lg ${newUrl
                  ? "bg-primary text-primary-foreground"
                  : "border !border-border bg-muted text-muted-foreground"
                }`}
              onClick={handleConfirmModal}
            >
              Next
            </button>
          </div>
        </div>
      </CommonModal>
      <ConfirmModal
        isOpen={openConfirmModal}
        onClose={handleConfirmModal}
        title="Confirm Changes"
        onConfirm={handleConfirmClick}
        loading={loading}
      />
    </>
  );
};

export default LoadURLModal;
